import { PromotionalProductImageProps } from '@coolblue-development/next-patterns/core';
import {
  CollectionName,
  FormattedCollectionName,
  PromotionalContent
} from '@features/product/typings';

const collectionNameMap: Record<CollectionName, FormattedCollectionName | undefined> = {
  Content: 'content',
  Products: 'product',
  Reviews: 'review',
  secondchance: 'second_chance_product',
  Temp: undefined,
  DeliveryInstallation: undefined,
  Animations: undefined
};

export function promotionalContentFactory(
  content: PromotionalContent
): PromotionalProductImageProps['promotionalContent'] | undefined {
  if (!content) return undefined;

  const mappedCollectionName: FormattedCollectionName | undefined =
    collectionNameMap[content?.promoIcon?.image?.collectionName || 'Content'] || 'content';

  return {
    promoIcon:
      content.promoIcon && content.promoIcon?.image?.id
        ? {
            altText: content.promoIcon.altText ?? '',
            image: {
              id: content.promoIcon?.image?.id ?? '',
              collectionName: mappedCollectionName
            },
            details: content.promoIcon.details
              ? {
                  title: content.promoIcon.details.title ?? '',
                  explanation: content.promoIcon.details.explanation ?? ''
                }
              : undefined
          }
        : undefined,
    promoLabel: content.promoLabel
      ? {
          label: content.promoLabel.label ?? '',
          details: content.promoLabel.details
            ? {
                title: content.promoLabel.details.title ?? '',
                explanation: content.promoLabel.details.explanation ?? ''
              }
            : undefined
        }
      : undefined
  };
}
